import "../App.css";
import Banner from "./Banner";
import Info from "./Info";
import OtherCourses from "./OtherCourses";

function LandingPage({ onLoginClick }) {
  return (
    <div>
      <Banner onLoginClick={ onLoginClick }/>
      <Info />
      <OtherCourses />
    </div>
  );
}

export default LandingPage;